import { ResumeRequestComponent } from './../resume-request/resume-request.component';
import { InvitesCerditsComponent } from './../invites-cerdits/invites-cerdits.component';
import { ActivatedRoute } from '@angular/router';
import { WelcomeWidgetComponent } from './../welcome-widget/welcome-widget.component';
import { JobSubmitSkillfilterComponent } from './../job-submit-skillfilter/job-submit-skillfilter.component';
import { PeopleWithSimilarNameComponent } from './../people-with-similar-name/people-with-similar-name.component';
import { EmptyWidgetComponent } from './../empty-widget/empty-widget.component';
import { HashtagsToFollowComponent } from './../hashtags-to-follow/hashtags-to-follow.component';
import { PeopleInyourNetworkComponent } from './../people-inyour-network/people-inyour-network.component';
import { SponsoredAdsComponent } from './../sponsored-ads/sponsored-ads.component';
import { PromotedAdsComponent } from './../promoted-ads/promoted-ads.component';
// import { CommonProfileInfoComponent } from './../common-profile-info/common-profile-info.component';
import { JobsYouMightBeIntrestedInComponent } from './../jobs-you-might-be-intrested-in/jobs-you-might-be-intrested-in.component';
import { VisitorsComponent } from './../visitors/visitors.component';
import { TrendingPostComponent } from './../trending-post/trending-post.component';
import { TrendingHashtagComponent } from './../trending-hashtag/trending-hashtag.component';
import { TrendingCommunityComponent } from './../trending-community/trending-community.component';
import { SimilarCommunityComponent } from './../similar-community/similar-community.component';
import { SimilarBusinessNearYouComponent } from './../similar-business-near-you/similar-business-near-you.component';
import { ProfileCompletionComponent } from './../profile-completion/profile-completion.component';
import { PeopleYouMayKnowComponent } from './../people-you-may-know/people-you-may-know.component';
import { InviteCollegueComponent } from './../invite-collegue/invite-collegue.component';
import { HashtagsYouMayLikeComponent } from './../hashtags-you-may-like/hashtags-you-may-like.component';
import { FollowCareonlineComponent } from './../follow-careonline/follow-careonline.component';
import { ConnectionsComponent } from './../connections/connections.component';
import { CommunityAdminComponent } from './../community-admin/community-admin.component';
import { CollegueYouMayKnowComponent } from './../collegue-you-may-know/collegue-you-may-know.component';
import { SocialMediaComponent } from './../social-media/social-media.component';
import { WidgetComponent } from './../widget/widget.component';
import { ApiService } from './../../services/api.service';
import { CareonlineTodayComponent } from '../careonline-today/careonline-today.component';
import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef, Injector, InjectionToken } from '@angular/core';
import { WIDGET_DATA } from 'src/app/components/suggestions/suggestions.component';
import { CopywriteComponent } from '../copywrite/copywrite.component';
import { NodataFoundComponent } from '../nodata-found/nodata-found.component';
import { BusinessbusinessComplteDataComponent } from '../business-profile-complete/business-profile-complete.component';
import { CommunityProfileCompleteComponent } from '../community-profile-complete/community-profile-complete.component';
import { CommonValues } from 'src/app/services/commonValues';
import { Subscription, Subject, takeUntil } from 'rxjs';
import { SearchData } from 'src/app/services/searchData';
import { FollowerComponent } from '../follower/follower.component';
import { PageType } from 'src/app/services/pageTypes';
import { CardComponent } from '../card/card.component';
import { BToFollowComponent } from '../b-to-follow/b-to-follow.component';
import { IntersectionStatus } from 'src/app/directives/from-intersection-observer';
import { CandidateYouMightBeIntrestedInComponent } from '../candidate-you-might-be-intrested-in/candidate-you-might-be-intrested-in.component';
import { FeaturedCandidateComponent } from '../featured-candidate/featured-candidate.component';
import { FeaturedJobsComponent } from '../featured-jobs/featured-jobs.component';
import { SuggestedCandidateComponent } from '../suggested-candidate/suggested-candidate.component';
import { SuggestedJobComponent } from '../suggested-job/suggested-job.component';
import { JobInviteComponent } from '../job-invite/job-invite.component';
import { CandidateInviteComponent } from '../candidate-invite/candidate-invite.component';
import { PriceAvilalbleComponent } from '../price-avilalble/price-avilalble.component';

/**
 * CommonWidgetComponent - Dynamic Widget Container
 *
 * ARCHITECTURE NOTE:
 * This component uses Angular's built-in NgComponentOutlet for dynamic component loading.
 * Widget inputs are passed via ngComponentOutletInputs property (Angular 14+).
 *
 * All widget components remain standalone and are loaded dynamically.
 * The widget mapping is maintained in the constructor.
 */
@Component({
  selector: 'app-common-widget',
  templateUrl: './common-widget.component.html',
  styleUrls: ['./common-widget.component.scss']
})



export class CommonWidgetComponent implements OnInit,OnDestroy {
  @Input() page: any;
  @Input() inputData: any;
  @Input() showflag: any;
  @Input() hideCompelte: any;
  @Input() showsuggJobsData: any;

  //@Input() userType: any;
  @Input() timeout: any = 0;
  WidgetList: any = [];
  inputs: any;
  userBasedmenu: any = {};
  widget: any;
  _userType: String = null;
  viewByMembers: boolean = null;
  private destroy$ = new Subject<void>();

  lastWidget: any;
  commondata: any = {};

  @Input() set userType(userType: String) {
    this._userType = userType;
    if (this._userType != null && this.WidgetList.length > 0) {
      this.refresh();
    }
  }

  /** Widget ids the host never wants rendered here (e.g. the business page
   *  hides Profile Completion because it's in its left column). Checked in the
   *  template, so it wins over every show/hide path. Empty = no change. */
  @Input() hiddenWidgetIds: string[] = [];

  // ── Business page wireframe sidebar (only set by business.component's
  // `useWireframeSidebar` block). When unset, none of this runs and every
  // page keeps its existing widget logic. ──
  private _wfView: 'ADMIN' | 'MEMBER' | null = null;
  /** Viewed business id, passed to the injected Similar Companies widget. */
  @Input() wireframeBusinessId: string;
  @Input() set wireframeBusinessView(view: 'ADMIN' | 'MEMBER' | null) {
    this._wfView = view || null;
    if (this._wfView && this.WidgetList.length > 0) {
      this.applyWireframeBusinessLayout();
    }
  }

  @Input() set viewByMember(userFlag: any) {
    this.viewByMembers = userFlag?.viewingAsMember === 'true'?true:false;
    if (this.viewByMembers != null && this.WidgetList.length > 0) {
      this.viewadmin();
      // Trigger change detection to update the UI
      try {
        this.cdr.detectChanges();
      } catch (error) {
        console.warn('Change detection error in viewByMember setter:', error);
      }
    }
  }


  // Removed outputs - commonFunction should not be an @Output binding
  // The hideComponent callback is handled internally
  outputs = {};

  showWelcomePostWidget: boolean = false
  loopCount = Array(6).fill(0).map((x, i) => i);
  constructor(private api: ApiService, private a_route: ActivatedRoute, private commonvalues: CommonValues, private pageType: PageType, private searchData: SearchData, private cdr: ChangeDetectorRef, public injector: Injector) {
    this.widget = {
      "BusinessToFollowComponent": BToFollowComponent,
      "BToFollowComponent": BToFollowComponent,
      "CommunityProfileCompleteComponent": CommunityProfileCompleteComponent,
      "BusinessProfileCompleteComponent": BusinessbusinessComplteDataComponent,
      "CareonlineTodayComponent": CareonlineTodayComponent,
      "CollegueYouMayKnowComponent": CollegueYouMayKnowComponent,
      "ColleagueYouMayKnowComponent": CollegueYouMayKnowComponent, // Alternate spelling
      "WelcomeWidgetComponent": WelcomeWidgetComponent,
      "CommunityAdminComponent": CommunityAdminComponent,
      "ConnectionsComponent": ConnectionsComponent,
      "FollowCareonlineComponent": FollowCareonlineComponent,
      "HashtagsYouMayLikeComponent": HashtagsYouMayLikeComponent,
      "InviteCollegueComponent": InviteCollegueComponent,
      "PeopleYouMayKnowComponent": PeopleYouMayKnowComponent,
      "ProfileCompletionComponent": ProfileCompletionComponent,
      "SimilarBusinessNearYouComponent": SimilarBusinessNearYouComponent,
      "SimilarCommunityComponent": SimilarCommunityComponent,
      "TrendingCommunityComponent": TrendingCommunityComponent,
      "TrendingHashtagComponent": TrendingHashtagComponent,
      "PeopleWithSimilarNameComponent": PeopleWithSimilarNameComponent,
      "TrendingPostComponent": TrendingPostComponent,
      "VisitorsComponent": VisitorsComponent,
      "WidgetComponent": WidgetComponent,
      "JobsYouMightBeIntrestedInComponent": JobsYouMightBeIntrestedInComponent,
      // "CommonProfileInfoComponent": CommonProfileInfoComponent,
      "PromotedAdsComponent": PromotedAdsComponent,
      "SponsoredAdsComponent": SponsoredAdsComponent,
      "PeopleInyourNetworkComponent": PeopleInyourNetworkComponent,
      "HashtagsToFollowComponent": HashtagsToFollowComponent,
      "EmptyWidgetComponent": EmptyWidgetComponent,
      "CopywriteComponent": CopywriteComponent,
      "NodataFoundComponent": NodataFoundComponent,
      "SocialMediaComponent": SocialMediaComponent,
      "FollowerComponent": FollowerComponent,
      "CardComponent": CardComponent,
      "JobSubmitSkillfilterComponent": JobSubmitSkillfilterComponent,
      "CandidateYouMightBeIntrestedInComponent": CandidateYouMightBeIntrestedInComponent,
      "SuggestedJobComponent": SuggestedJobComponent,
      "SuggestedCandidateComponent": SuggestedCandidateComponent,
      "FeaturedCandidateComponent": FeaturedCandidateComponent,
      "FeaturedJobsComponent": FeaturedJobsComponent,
      "InvitesCerditsComponent": InvitesCerditsComponent,
      "ResumeRequestComponent": ResumeRequestComponent,
      "JobInviteComponent": JobInviteComponent,
      "CandidateInviteComponent": CandidateInviteComponent,
      "PriceAvilalbleComponent": PriceAvilalbleComponent,
    };

    this.commonvalues.getbusinessid()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.commondata = res;
      });
    
    this.pageType.getPageName()
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        // this.Widgetlist(null);
        this.apicall();
      });

  }

  businessOnActive : boolean = false;
  communityOnActive : boolean = false;
  teamOnActive: boolean = false;
  networkActive: boolean = false;
  ngOnInit() {
    this.a_route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {

      const d  = window.location;
      const value = d.hash.split("?")[0];
      console.log("Routed value" , value);

      this.businessOnActive = value === "#/business/post" ? true : false;
      this.communityOnActive = value === "#/community" ? true : false;
      this.networkActive = value === "#/networkPage/home" ? true : false;
      this.teamOnActive = value === "#/teamPage/home" ? true : false;

      if (res.showWelcomePost == 'true') {
        this.showWelcomePostWidget = true
      } else {
        this.showWelcomePostWidget = false
      }

    })
    // this.Widgetlist(null);
    this.apicall();

  }





  onVisibilityChanged(index: number, status: IntersectionStatus) {
    // this.visibilityStatus[index] = status;
    if (status) {
      var val: any = {}
      val.position = window.pageYOffset;
      this.searchData.setSticky(val)
    }
  }

  trackByIndex(index: number) {
    return index;
  }

  // Track widgets by their unique ID for better performance
  trackByWidgetId(index: number, item: any): string {
    return item?.widgetId || index;
  }


  Widgetlist(removecomp) { 

    if (removecomp != null) {
      delete this.widget.removecomp;
      this.apicall();
    }

  }
  loadAPIcall=false;
  apicall() {
    setTimeout(() => {


      if (this.page && this.page != "") {
        let data: any = {}
        data.page = this.page;

        this.loadAPIcall=true
        this.api.create('widget/list', data)
          .pipe(takeUntil(this.destroy$))
          .subscribe(res => {
          console.log('CommonWidget: API response for page', this.page, 'inputData', this.inputData, ':', res);
          if (res != undefined && res) {

            setTimeout(() => {
              try {
              this.loadAPIcall=false;
              this.WidgetList = [];
              res.forEach((element, i) => {
                // Skip disabled widgets (kept in codebase but not in use)
                if (element.widgetName === 'CToFollowComponent' || element.widgetId === 'COMMUNITY_TO_FOLLOW') {
                  return;
                }

                element.show = true;
              if (element.userType === "ALL") {
                element.show = true;
              } else {
                element.show = false;
              }

              if (element.widgetId == 'WELCOME_WIDGET' && this.showWelcomePostWidget == false) {
                element.show = false
              } else if (element.widgetId == 'WELCOME_WIDGET' && this.showWelcomePostWidget == true) {
                element.show = true
              }

              if (this._userType == 'ADMIN') {
                element.show = true;
              }

              // Admin widget visibility check - only show ADMIN widgets to superadmin/admin users
              // Fixed: Use AND (&&) instead of OR (||) to correctly hide only when BOTH are false
              // Also handle case-insensitive comparison and null/undefined values
              const isSuperAdmin = localStorage.getItem('isSuperAdmin');
              const isAdmin = localStorage.getItem('isAdmin');
              const viewAsAdmin = localStorage.getItem('viewAsadmin');

              // Debug logging for admin widgets
              if (element.userType == 'ADMIN') {
                console.log(`CommonWidget: Admin widget "${element.widgetId}" - isSuperAdmin: "${isSuperAdmin}", isAdmin: "${isAdmin}", viewAsAdmin: "${viewAsAdmin}", _userType: "${this._userType}", viewByMembers: ${this.viewByMembers}`);
              }

              const isAdminUser = isSuperAdmin === 'true' || isAdmin === 'true';
              const isNotAdminUser = isSuperAdmin === 'false' && isAdmin === 'false';
              // viewAsadmin='true' means "viewing as admin" (show widgets), 'false' means "viewing as member" (hide widgets)
              const isViewingAsAdmin = viewAsAdmin === 'true';
              const isViewingAsMember = viewAsAdmin === 'false';

              if (element.userType == 'ADMIN') {
                // Priority order:
                // 1. If viewByMembers Input is true, hide admin widgets
                // 2. If explicitly viewing as admin (localStorage toggle), show admin widgets
                // 3. If explicitly viewing as member (localStorage toggle), hide admin widgets
                // 4. If user is admin (localStorage), show admin widgets
                // 5. If user is explicitly not admin, hide admin widgets
                // 6. Otherwise, keep current show value (from _userType check)
                if (this.viewByMembers === true) {
                  element.show = false;
                } else if (isViewingAsAdmin) {
                  element.show = true;
                } else if (isViewingAsMember) {
                  element.show = false;
                } else if (isAdminUser) {
                  element.show = true;
                } else if (isNotAdminUser) {
                  element.show = false;
                }
                // If none of the above (all values null), keep the show value from _userType check

                console.log(`CommonWidget: Admin widget "${element.widgetId}" final show: ${element.show}`);
              }

              if (this.hideCompelte == 'LandingBusiness' && element.widgetName == 'BusinessProfileCompleteComponent' && element.userType == 'ALL') {
                element.show = false;
              }

              if (this.hideCompelte == 'LandingCommunity' && element.widgetName == 'CommunityProfileCompleteComponent' && element.userType == 'ALL') {
                element.show = false;
              }

              if (this.inputData == 'COMMUNITY_CREATE_PAGE') {
                element.show = true;
              }

              if (this.inputData == 'BUSINESS_CREATION') {
                element.show = true;
              }

              // Filter out TRENDING_TODAY and BUSINESS_TO_FOLLOW for GIG_HOME_PAGE
              if (this.page == 'GIG_HOME_PAGE' &&
                  (element.widgetId == 'TRENDING_TODAY' || element.widgetId == 'BUSINESS_TO_FOLLOW')) {
                element.show = false;
              }

              // BUSINESS_LANDING_HOME_PAGE: Keep only specific widgets
              if (this.page == 'BUSINESS_LANDING_HOME_PAGE') {
                const allowedWidgets = ['PEOPLE_YOU_MAY_KNOW', 'PROMOTED_AD', 'SPONSORED_AD', 'JOBS_YOU_MIGHT_BE_INTERESTED_IN', 'PEOPLE_IN_YOUR_NETWORK'];
                if (!allowedWidgets.includes(element.widgetId)) {
                  element.show = false;
                }
              }

              // COMMUNITY_HOME_PAGE: Keep only specific widgets
              if (this.page == 'COMMUNITY_HOME_PAGE') {
                const allowedWidgets = ['COMMUNITY_ADMIN', 'PEOPLE_YOU_MAY_KNOW', 'PROMOTED_AD', 'SPONSORED_AD', 'PEOPLE_IN_YOUR_NETWORK'];
                if (!allowedWidgets.includes(element.widgetId)) {
                  element.show = false;
                }
              }

              // COMMUNITY_MEMBER_PAGE: Hide Trending Posts widget
              if (this.page == 'COMMUNITY_MEMBER_PAGE') {
                if (element.widgetId == 'TRENDING_POST' || element.widgetName == 'TrendingPostComponent') {
                  element.show = false;
                }
              }

              // BUSINESS_HOME_PAGE: Keep only specific widgets
              // Note: VISITORS is an admin-only widget (userType='ADMIN'), visibility controlled by admin check above
              if (this.page == 'BUSINESS_HOME_PAGE') {
                const allowedWidgets = [
                  'JOBS_YOU_MIGHT_BE_INTERESTED_IN',
                  'PEOPLE_YOU_MAY_KNOW',
                  'PROMOTED_AD',
                  'SPONSORED_AD',
                  'BUSINESS_PROFILE_COMPLETE',
                  'BUSINESS_COMPLETION',  // API returns this ID
                  'INVITE_CONNECTIONS',
                  'INVITE_YOUR_CONNECTION',  // API returns this ID
                  'VISITORS'
                ];
                // Only hide widgets not in allowedWidgets list
                // For ADMIN widgets in the list, preserve their visibility (already determined by admin check)
                if (!allowedWidgets.includes(element.widgetId)) {
                  element.show = false;
                }
              }

              // BUSINESS_COMMUNITY_PAGE: Keep specific widgets including VISITORS
              if (this.page == 'BUSINESS_COMMUNITY_PAGE') {
                const allowedWidgets = ['PEOPLE_YOU_MAY_KNOW', 'PROMOTED_AD', 'SPONSORED_AD', 'VISITORS'];
                if (!allowedWidgets.includes(element.widgetId)) {
                  element.show = false;
                }
              }

              // BUSINESS_JOB_PAGE: Keep specific widgets including Jobs from connections
              if (this.page == 'BUSINESS_JOB_PAGE') {
                const allowedWidgets = ['PEOPLE_YOU_MAY_KNOW', 'PROMOTED_AD', 'SPONSORED_AD', 'CANDIDATE_YOU_MIGHT_BE_INTERESTED_IN', 'JOBS_YOU_MIGHT_BE_INTERESTED_IN'];
                if (!allowedWidgets.includes(element.widgetId)) {
                  element.show = false;
                }
              }

              // Business Employee and Network pages: Keep only specific widgets
              if (['BUSINESS_EMPLOYEE_PAGE', 'BUSINESS_EMPLOYEE_REQ_PAGE', 'NETWORK_HOME_PAGE', 'NETWORK_ABOUT_PAGE', 'NETWORK_MEMBER_PAGE'].includes(this.page)) {
                const allowedWidgets = ['PEOPLE_YOU_MAY_KNOW', 'PROMOTED_AD', 'SPONSORED_AD'];
                if (!allowedWidgets.includes(element.widgetId)) {
                  element.show = false;
                }
              }

              // BUSINESS_FOLLOWR_PAGE: Keep only specific widgets (for follower, followerRequest-sent pages)
              if (this.page === 'BUSINESS_FOLLOWR_PAGE') {
                const allowedWidgets = ['PEOPLE_YOU_MAY_KNOW', 'PROMOTED_AD', 'SPONSORED_AD'];
                if (!allowedWidgets.includes(element.widgetId)) {
                  element.show = false;
                }
              }

              // BUSINESS_ANALYTIC_PAGE: Keep only specific widgets
              if (this.page === 'BUSINESS_ANALYTIC_PAGE') {
                const allowedWidgets = ['PEOPLE_YOU_MAY_KNOW', 'PROMOTED_AD', 'SPONSORED_AD'];
                if (!allowedWidgets.includes(element.widgetId)) {
                  element.show = false;
                }
              }

              // BUSINESS_ADMIN_PAGE: Keep only specific widgets (for admin, business-settings pages)
              if (this.page === 'BUSINESS_ADMIN_PAGE') {
                const allowedWidgets = ['PEOPLE_YOU_MAY_KNOW', 'PROMOTED_AD', 'SPONSORED_AD', 'VISITORS'];
                if (!allowedWidgets.includes(element.widgetId)) {
                  element.show = false;
                }
              }

              // BUSINESS_DEACTIVATE_PAGE: Keep only specific widgets
              if (this.page === 'BUSINESS_DEACTIVATE_PAGE') {
                const allowedWidgets = ['PEOPLE_YOU_MAY_KNOW', 'PROMOTED_AD', 'SPONSORED_AD'];
                if (!allowedWidgets.includes(element.widgetId)) {
                  element.show = false;
                }
              }
              //  if (this.showflag == false && element.widgetId=='FEATURED_JOB'){
              //   element.show = true;
              // }



              element.ready = true;

              // Create a new inputs object for each widget to avoid shared references
              const widgetInputs: any = {
                inputData: this.inputData,
                page: this.page,
                widgetDesc: element.widgetDesc,
                suggestion: this.showsuggJobsData,
                // Pass hideComponent callback as commonFunction for widgets that emit to hide themselves
                commonFunction: this.hideComponent.bind(this)
              };

              console.log('CommonWidget: Creating widget', element.widgetName, 'with inputs:', widgetInputs);

              element.widgetData = widgetInputs;

              // Create injector for this widget to pass data via WIDGET_DATA token
              element.widgetInjector = this.createWidgetInjector(widgetInputs);

              this.WidgetList.push(element)
              var temp = [];
              temp = this.duplicate(this.WidgetList);
              this.WidgetList = temp;
            });

              // Business wireframe sidebar: fixed list + order (no-op otherwise).
              if (this._wfView) {
                this.applyWireframeBusinessLayout(false);
              }

              if (this.WidgetList.length != 0) {
                this.lastWidget = this.WidgetList[this.WidgetList.length - 1].widgetId
              }

              // Summary log of visible widgets
              const visibleWidgets = this.WidgetList.filter(w => w.show).map(w => w.widgetId);
              const hiddenWidgets = this.WidgetList.filter(w => !w.show).map(w => w.widgetId);
              console.log('CommonWidget: Visible widgets:', visibleWidgets);
              console.log('CommonWidget: Hidden widgets:', hiddenWidgets);

                try {
                  this.cdr.detectChanges();
                } catch (error) {
                  console.warn('Change detection error in common-widget:', error);
                }

              } catch (error) {
                console.error('Widget processing error:', error);
                this.loadAPIcall = false;
                // Set widgets to show fallback mode
                this.WidgetList = res.map(element => ({
                  ...element,
                  show: true,
                  ready: true,
                  hasError: true
                }));
              }
            }, 0);

          }
        }, err => {

          if (err.status == 500) {

          }

        });
      }
    }, this.timeout);
  }

  ngOnDestroy() {
    // Complete all subscriptions using destroy$ subject
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Removed isKnownWidget method since we're using placeholder approach






  refresh(): void {
    console.log('CommonWidget: refresh() called with _userType:', this._userType);
    var temp = [];
    temp = this.duplicate(this.WidgetList);
    this.WidgetList = temp;
    this.WidgetList.forEach(element => {
      // For ADMIN widgets, check if current user is admin
      if (element.userType == 'ADMIN') {
        // First, check if _userType Input indicates admin
        if (this._userType == 'ADMIN') {
          element.show = true;
        }

        // Then check localStorage for admin flags
        const isSuperAdmin = localStorage.getItem('isSuperAdmin');
        const isAdmin = localStorage.getItem('isAdmin');
        const viewAsAdmin = localStorage.getItem('viewAsadmin');

        console.log(`CommonWidget refresh: Admin widget "${element.widgetId}" - isSuperAdmin: "${isSuperAdmin}", isAdmin: "${isAdmin}", viewAsAdmin: "${viewAsAdmin}"`);

        const isAdminUser = isSuperAdmin === 'true' || isAdmin === 'true';
        const isNotAdminUser = isSuperAdmin === 'false' && isAdmin === 'false';
        const isViewingAsAdmin = viewAsAdmin === 'true';
        const isViewingAsMember = viewAsAdmin === 'false';

        // Priority order (same as apicall)
        if (isViewingAsAdmin) {
          element.show = true;
        } else if (isViewingAsMember) {
          element.show = false;
        } else if (isAdminUser) {
          element.show = true;
        } else if (isNotAdminUser) {
          element.show = false;
        }
        // If none match, keep previous show value

        console.log(`CommonWidget refresh: Admin widget "${element.widgetId}" final show: ${element.show}`);
      } else if (element.userType != "ALL" && element.userType == this._userType) {
        element.show = true;
      }

      if (this.inputData == 'COMMUNITY_CREATE_PAGE') {
        element.show = true;
      }

      if (this.inputData == 'BUSINESS_CREATION') {
        element.show = true;
      }

      if (this.inputData == 'PROFILE_CREATE_PAGE') {
        element.show = true;
      }
    });

    // Business wireframe sidebar: re-apply its list (no-op otherwise).
    if (this._wfView) {
      this.applyWireframeBusinessLayout(false);
    }

    // Trigger change detection to update the UI
    try {
      this.cdr.detectChanges();
    } catch (error) {
      console.warn('Change detection error in refresh:', error);
    }
  }

  viewadmin() {
    console.log('CommonWidget: viewadmin() called with viewByMembers:', this.viewByMembers);
    this.WidgetList.forEach(element => {
      if (element.userType == 'ADMIN') {
        const isSuperAdmin = localStorage.getItem('isSuperAdmin');
        const isAdmin = localStorage.getItem('isAdmin');
        const viewAsAdmin = localStorage.getItem('viewAsadmin');

        console.log(`CommonWidget viewadmin: Admin widget "${element.widgetId}" - isSuperAdmin: "${isSuperAdmin}", isAdmin: "${isAdmin}", viewAsAdmin: "${viewAsAdmin}", viewByMembers: ${this.viewByMembers}`);

        const isAdminUser = isSuperAdmin === 'true' || isAdmin === 'true';
        const isNotAdminUser = isSuperAdmin === 'false' && isAdmin === 'false';
        const isViewingAsAdmin = viewAsAdmin === 'true';
        const isViewingAsMember = viewAsAdmin === 'false';

        // Priority: viewByMembers Input > localStorage viewAsadmin > localStorage admin flags
        if (this.viewByMembers === true) {
          element.show = false;
        } else if (isViewingAsAdmin) {
          element.show = true;
        } else if (isViewingAsMember) {
          element.show = false;
        } else if (isAdminUser) {
          element.show = true;
        } else if (isNotAdminUser) {
          element.show = false;
        }

        console.log(`CommonWidget viewadmin: Admin widget "${element.widgetId}" final show: ${element.show}`);
      }
    });

    // Business wireframe sidebar: re-apply its list after the admin toggle.
    if (this._wfView) {
      this.applyWireframeBusinessLayout(false);
    }

    // Trigger change detection to update the UI
    try {
      this.cdr.detectChanges();
    } catch (error) {
      console.warn('Change detection error in viewadmin:', error);
    }
  }

  duplicate(data) {
    var temp = [];
    var arr = data.filter(function (el) {
      // If it is not a duplicate, return true
      if (temp.indexOf(el.widgetId) == -1) {
        temp.push(el.widgetId);
        return true;
      }
      return false;
    });
    return arr;
  }


  hideComponent(type): void {
    setTimeout(() => {
      this.WidgetList.forEach(element => {
        if (element.widgetName == type.widgetName) {
          if (type.hide == true) {
            element.show = false;
          }
          else if (type.hide == false) {
            element.show = true;
          }
          // Remembered so the wireframe sidebar re-sort doesn't re-show a
          // widget that hid itself (no data). Unused elsewhere.
          element.wfSelfHidden = type.hide == true;
        }
      });

      this.viewadmin();
      this.cdr.detectChanges();
    }, 0);
  }

  /** Business page wireframe sidebar: show exactly the wireframe widgets for
   *  the view, in wireframe order. Runs only when `wireframeBusinessView` is
   *  set. Admin: Visitors, Invite, Jobs, PYMK, Promoted, Sponsored.
   *  Member: Jobs, PYMK, Similar Companies, Sponsored. */
  private applyWireframeBusinessLayout(detect = true): void {
    const order: Record<string, number> = this._wfView === 'ADMIN'
      ? {
        VISITORS: 0,
        INVITE_CONNECTIONS: 1,
        INVITE_YOUR_CONNECTION: 1,
        JOBS_YOU_MIGHT_BE_INTERESTED_IN: 2,
        PEOPLE_YOU_MAY_KNOW: 3,
        PROMOTED_AD: 4,
        SPONSORED_AD: 5
      }
      : {
        JOBS_YOU_MIGHT_BE_INTERESTED_IN: 0,
        PEOPLE_YOU_MAY_KNOW: 1,
        WF_SIMILAR_COMPANIES: 2,
        SPONSORED_AD: 3
      };

    // Similar Companies isn't in the backend list for this page — add it once.
    if (!this.WidgetList.some(w => w.widgetId === 'WF_SIMILAR_COMPANIES')) {
      const data: any = {
        inputData: this.inputData,
        page: this.page,
        widgetDesc: 'Similar Companies',
        similarBusinessId: this.wireframeBusinessId,
        commonFunction: this.hideComponent.bind(this)
      };
      this.WidgetList.push({
        widgetId: 'WF_SIMILAR_COMPANIES',
        widgetName: 'SimilarBusinessNearYouComponent',
        widgetDesc: 'Similar Companies',
        userType: 'ALL',
        ready: true,
        show: false,
        widgetData: data,
        widgetInjector: this.createWidgetInjector(data)
      });
    }

    const rank = (w: any) => (w.widgetId in order ? order[w.widgetId] : 999);
    this.WidgetList.forEach(w => {
      w.show = w.widgetId in order && !w.wfSelfHidden;
    });
    // New array so *ngFor re-orders; trackBy widgetId keeps the components.
    this.WidgetList = [...this.WidgetList].sort((a, b) => rank(a) - rank(b));

    if (detect) {
      try {
        this.cdr.detectChanges();
      } catch (error) {
        console.warn('Change detection error in wireframe layout:', error);
      }
    }
  }

  // Create injector for widget to pass data via WIDGET_DATA token
  createWidgetInjector(widgetData: any): Injector {
    return Injector.create({
      providers: [
        { provide: WIDGET_DATA, useValue: widgetData }
      ],
      parent: this.injector
    });
  }

}
